export default __webpack_public_path__ + "static/media/ngif-logo.176d16fd.jpg";